module.exports = __webpack_public_path__ + "static/img/87-1.69ed947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/87-1.jpg
// module id = IQBa
// module chunks = 0